import {
	get,
	post
} from './http'

export default {
	createEventOrder(OpenId, Contact, Mobile, TicketNumber, FlightNumber, FlightDate, GoodsName, CredentialsUrl, StartCity,
		EndCity, IsGo, Remarks = '') {
		return post('Event/createEventOrder', {
			openid: OpenId,
			Contact: Contact,
			Mobile: Mobile,
			TicketNumber: TicketNumber,
			FlightNumber: FlightNumber,
			FlightDate: FlightDate,
			GoodsName: GoodsName,
			CredentialsUrl: CredentialsUrl,
			StartCity: StartCity,
			EndCity: EndCity,
			Remarks: Remarks,
			IsGo: IsGo
		});
	},
	getEventOrderInfo(OrderID) {
		return get(`Event/getEventOrderInfo`, {
			orderid: OrderID
		});
	},
	getEventOrderByUser(OpenId) {
		return get('Event/getEventOrderByUser', {
			openid: OpenId
		});
	},
	managerCheckOrder(OpenId, OrderId, SupportGoods, EventState) {
		return post('Event/managerCheckOrder', {
			openid: OpenId,
			OrderId: OrderId,
			SupportGoods: SupportGoods,
			EventState: EventState
		});
	},
  getH5UploadImagePath(OpenId, MediaId) {
    return post('event/getH5UploadImagePath', {
    	OpenId: OpenId,
    	MediaId: MediaId,
    });
  }
}



// WEBPACK FOOTER //
// ./src/request/eventApi.js